/**
 * websockt模块，主要负责socket的创建，事件管理
 * @author mingxin.huang
 * @updata 2013.1.11
 */
$.module('MM.util.socket', function () {
  WEB_SOCKET_SWF_LOCATION = MM.core.getRoot(
    '/scripts/util/socket.io/WebSocketMainInsecure.swf',
    'base',
  );

  /**
   * socket模块
   * @param {Object} params 创建socket所需参数
   * {
   * 	url : String, //socket地址
   * 	onMsg : Function, //收到消息的回调
   * 	onConnect : Function, //打开链接的回调
   * 	onReconnect : Function, //重连回调
   * 	onDisconnect : Function //断开回调
   * }
   */
  function Socket(params) {
    if (params.path) {
      this.socket = ioNew(params.url, {
        query: params.query || {},
        transports: ['websocket'],
      });
    } else {
      this.socket = params.isNew
        ? ioNew.connect(params.url, {
            transports: ['websocket'],
          })
        : io.connect(params.url, {
            transports: ['websocket'],
          });
    }

    this.onMsg = params.onMsg || null;
    this.onConnect = params.onConnect || null;
    this.onReconnect = params.onReconnect || null;
    this.onDisconnect = params.onDisconnect || null;
    this.startTime = Date.now(); //记录开始时间，用来计算连接时长
    this.domain = params.url.replace(/http(s?):\/\//, '', '').split('/')[0]; // 当前连接的域名

    var that = this;
    // 绑定消息事件，处理收到的消息
    this.socket.on('message', function (dataStr) {
      var data = typeof dataStr === 'string' ? $.parseJSON(dataStr) : dataStr;

      if (!data.action) {
        var tempData = {
          action: 'message.chat',
        };
        tempData.msg = data;
        data = tempData;
      }

      if (data.action === 'delay.check') {
        that.track('delay', { delayTime: Date.now() - data.timestamp });

        return;
      }

      var action = data.action.split('.');

      data.action = {
        module: action.shift(),
        action: action.join('.'),
      };

      // MM.core.debug('socket msg : ', data);
      if ($.isFunction(that.onMsg)) {
        that.onMsg(data);
      }
    });

    // 绑定连接成功事件
    this.socket.on('connect', function () {
      if ($.isFunction(that.onConnect)) {
        that.onConnect();
      }

      that.track('connect', { connectTime: Date.now() - that.startTime });

      that.send({ action: 'delay.check', timestamp: Date.now() });
    });

    // 绑定重连事件
    this.socket.on('reconnect', function () {
      if ($.isFunction(that.onReconnect)) {
        that.onReconnect();
      }

      that.track('reconnect');

      that.startTime = Date.now();
    });

    // 绑定断开连接事件
    this.socket.on('disconnect', function () {
      if ($.isFunction(that.onDisconnect)) {
        that.onDisconnect();
      }

      that.track('disconnect');

      that.startTime = Date.now();
    });
  }

  /**
   * 发送消息方法
   * @param  {Object} params 发送消息内容
   */
  Socket.prototype.send = function (params) {
    this.socket.send(JSON.stringify(params));
  };

  /**
   * 获得当前的socket对象
   * @return {Object} [description]
   */
  Socket.prototype.getSocket = function () {
    return this.socket;
  };

  /**
   * 断开连接
   * @return {[type]} [description]
   */
  Socket.prototype.disconnect = function () {
    this.socket.disconnect();
  };

  /**
   * 聊天向神策发送相关消息方法
   * @param  {String} action 神策action
   * @param  {Object} params 神策额外参数
   * @return {[type]}        [description]
   */
  Socket.prototype.track = function (action, params) {
    // 临时去除日志
    var defaultParams = {
      user_memeid: MM.user.getUserId() + '',
      domain: this.domain,
      type: this.domain.indexOf('ws') > -1 ? 'ws' : 'im',
      device: 'pc',
      version: MM.config.version,
    };

    if (defaultParams.type === 'ws') {
      defaultParams.roomId = MM.live.room.getRoomId() + '';
    }

    params = $.extend(defaultParams, params);

    sa.track('socket_' + action, params);
  };

  return {
    createSocket: function (params) {
      return new Socket(params);
    },
  };
});
